import { render, staticRenderFns } from "./WelcomeTop.vue?vue&type=template&id=27bb1895&"
import script from "./WelcomeTop.vue?vue&type=script&lang=js&"
export * from "./WelcomeTop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports